/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/subtract'
export default icon
